"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostAvatar = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var user_1 = require("../../model/user");
var service_1 = require("../../../library/base/service");
var PostAvatar = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(PostAvatar, _super);
    function PostAvatar() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '上传用户头像';
        _this.code = '101084';
        _this.desc = '';
        _this.requestParams = new user_1.PostAvatarRequest();
        // public responseParams: LoginRequest;
        _this.method = fetch_1.Methods.POSTFILE;
        return _this;
        // public security = false;
    }
    return PostAvatar;
}(service_1.BaseService));
exports.PostAvatar = PostAvatar;
//# sourceMappingURL=postAvatar.js.map